import { render } from "./LoginLinkSentDialog.vue?vue&type=template&id=66af1bfd"
import script from "./LoginLinkSentDialog.vue?vue&type=script&lang=js"
export * from "./LoginLinkSentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__